export default interface ISalesProduct extends ISalesProductInput {
  id: number;
  rowDate: Date;
}

export interface ISalesProductInput {
  code: string;
  name: string;
  description?: string;
  status: SalesProductStatus;
  productImage?: string;
}

export enum SalesProductStatus {
  Active = "A",
  Inactive = "I",
  Hold = "H",
}
